import React, {useEffect, useMemo, useRef, useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {Button, Collapse, IconButton, TextField} from "@material-ui/core";
import HelpSectionTOC from "./HelpSectionTOC";
import {useLocation} from "react-router-dom";
import Card from "@material-ui/core/Card";
import {Slide} from "@mui/material";
import ReactMarkdown from "react-markdown";
import {CloseArrow, EditIcon, OpenArrow} from "../../../helpers/Icons";
import {ENABLE_HELP_EDIT} from "../../../config";

const useStyles = makeStyles({
  root: {

  },
  selected: {
    backgroundColor: "#fffae5",
  },
  locator: {
    display:"flex",
    flexWrap:"wrap",
    gap:"0.25rem",
    fontSize: '0.7225rem',
    marginBottom: "0.35rem",
  },
  locatorRoot: {
    display:"flex",
    flexWrap:"wrap",
    gap:"0.25rem",
    fontSize: '0.7225rem',
    marginBottom: "0.35rem",
    fontWeight: 600
  },
  sticky: {
    position:"sticky",
    top: "-1px",
    // backgroundColor: "#71d0f9",
    // backgroundColor: "#9fe2ff",
    // backgroundColor: "#d4e9f2",
    // backgroundColor: "#cfebf7",
    // backgroundColor: "#c2dbff",
    // backgroundColor: "#cee2ff",
    // backgroundColor: "rgba(16, 175, 255, 0.12)",
    zIndex: 1,
    margin: "1rem 0 1rem 0",
    paddingBottom: "1px",
    "& > div:first-child": {
      backgroundColor: "#c9ecff",
    },
  },
  stickyRoot: {
    top: "0px",
    margin: "0 0 1rem 0",
    "& > div:first-child": {
      backgroundColor: "#267ea6",
      color: "#ffffff !important",
      fontWeight: 500,
    },
  },
  closed: {
    // backgroundColor: "#e2f5fd",
    // backgroundColor: "#eefaff",
    "& > div:first-child": {
      backgroundColor: "#f5fcff",
    },
    // backgroundColor: "rgba(16, 175, 255, 0.03)",
    // backgroundColor: "#effbff",
    margin: "1rem 0 1rem 0",
  },
  single: {
    margin: "1rem 0 0.25rem 0",
  },
  top: {
    display: "flex",
    gap: "1rem",
    justifyContent: "space-between",
    // backgroundColor: "inherit",
    color:"inherit"
  },
  topRoot: {
    padding:"2px 1rem 0",
    borderRadius: "0 0 4px 4px",
  },
  topSection: {
    padding:"4px 1rem 0",
    borderTop: "1px solid rgba(0,0,0,0.27)",
    borderRadius: "0 0 4px 4px"
  },
  topSingle: {
    margin:"4px 1rem 0",
    borderTop: "1px solid rgba(0,0,0,0.27)",
  },
  topText: {
    flexBasis: "fit-content",
    padding: "4px 0",
  },
  thumbnail: {
    minHeight: "48px",
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    padding: "4px 0",
    flex: 1,
    flexBasis: "33%",

  },
  thumbnailImage:{
    border: "1px solid rgba(0,0,0,0.87)",
    borderRadius: "4px",
    maxWidth: "calc(max(48px, min(300px, 100%)))",
    minWidth: "48px",
    maxHeight: "48px",
    boxSizing: "border-box",
  },
  order: {
    fontFamily:"monospace"
  },
  path: {
  },
  name: {
    display:"flex",
    gap:"0.25em",
    marginBottom: "0.5rem",
  },
  label: {
    backgroundColor: "#f00",
    color: "#fff",
    fontSize:"1rem",
    fontWeight: 600,
    boxSizing:"content-box",
    padding:"0 2px",
    borderRadius:"calc(0.625em + 2px)",
    minWidth:"1.25em",
    height:"calc(1.25em + 4px)",
    display:"flex",
    whiteSpace:"nowrap",
    justifyContent:"center",
    alignItems:"center",
  },
  title: {
    flexGrow: 1,
    fontSize: '1.35rem',
  },
  body: {
    backgroundColor: "#fff"
  },
  openBody: {
    borderLeft: "1px solid rgba(0,0,0,0.52)",
    paddingLeft: "8px"
  },
  content: {
    display: "flex",
    flexWrap: "wrap",
    gap: "0 0.5rem",
    padding:"0 1rem",
  },
  image: {
    flex: 1,
    flexBasis: "calc(min(400px, 100%))",
    paddingBottom:"0.25rem"
  },
  annotateLink:{
    width: "calc(min(600px, 100%))",
    textAlign: "center",
    fontSize: "0.7225rem"
  },
  annotateLinkButton:{
    fontSize: "0.7225rem",
    padding: "0 2px"
  },
  mainImage:{
    border: "2px solid rgba(0,0,0,0.87)",
    borderRadius: "4px",
    maxWidth: "calc(min(600px, 100%))",
    maxHeight: "calc(min(480px, 75dvh))",
    cursor: "pointer",
    boxSizing: "border-box"
  },
  mainImageLg:{
    border: "2px solid rgba(0,0,0,0.87)",
    borderRadius: "4px",
    maxWidth: "100%",
    cursor: "pointer",
    boxSizing: "border-box"
  },
  imagesToc:{
    display: "flex",
    flexWrap: "wrap-reverse",
    // gap: "0.5rem 1rem",
    width: "100%"
  },
  toc:{
    padding: "0 1rem 1rem 0"
  },
  altImages:{
    flex: 1,
    flexBasis: "400px",
  },
  text: {
    fontSize: '1rem',
    flex: 1,
    flexBasis: "30rem",
    "& code":{
      backgroundColor: "rgba(0,0,0,0.05)",
      padding: "0.15em",
      borderRadius: "4px",
      lineHeight: "1.85em",
    },
    "& pre":{
      whiteSpace: "pre-wrap",
      backgroundColor: "rgba(0,0,0,0.05)",
      padding: "0.25em",
      borderRadius: "4px",
      "& code": {
        backgroundColor: "unset",
        padding: 0,
        borderRadius: 0,
        lineHeight: "initial"
      }
    },
  },
  images: { },
  sections: { },
  anchorRoot:{
    position: "relative",
    top: "1px",
    height: 0,
    overflow: "visible",
    zIndex: -1,
    opacity: 0
  },
  anchor:{
    position:"absolute",
    width:"100%",
    bottom:0,
  },
  breadcrumb:{
    color:"inherit",
    "&:visited": {
      color: "inherit"
    },
    "&:hover": {
      opacity: 0.66
    }
  },
  sectionButton:{
    height: "100%",
    alignSelf: "center",
  },
  edit: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
    padding: "0.5rem",
  },
  editActions: {
    display: "flex",
    gap: "0.5rem",
  },
});

const clickBreadcrumb = (order, e) => {
  if(!!e) {
    e.preventDefault();
    e.stopPropagation();
  }
  window.location =`#help_${order}`;
};
const makeLink = (order, text, className) =>
  <a key={order} className={className} href={`#help_${order}`}
    onClick={clickBreadcrumb.bind(this, order)}>{text}</a>;
const separator = ">";

const makeBreadcrumbs = (order, path, className) => {
  if(!path || path.length === 0){
    return [];
  }
  const breadcrumbs = [];
  breadcrumbs.push(makeLink(path[0].order, path[0].title, className));
  path.slice(1,path.length).forEach(p => {
    breadcrumbs.push(<div key={`separator_${p.order}`}>{separator}</div>);
    breadcrumbs.push(makeLink(p.order, p.title, className))
  })
  return breadcrumbs;
};

function LinkRenderer(props) {
  return (
    <a
      href={props.href}
      rel='nofollow noreferrer noopener'
      target={props.href?.includes?.("#help_") ? "" : "_blank"}
    >
      {props.children}
    </a>);
}

function HelpSection(props) {
  const { section, parentStickyTitle, addHelpEdit, isAdmin, currentSection, shouldAnnotated=false } = props;
  section.fullOrder = section.fullOrder || "";
  const classes = useStyles();
  const hasImages = Object.keys(section.images||[]).length > 0;
  const hasAltImages = Object.keys(section.images||[]).length > 1;
  const hasSections = Object.keys(section.sections||[]).length > 0;
  const hasChildren = hasImages || hasSections;
  const isSectionRoot = section.fullOrder.endsWith("0.0") && section.order === "" && section.group === "";
  const partialOrder = section.fullOrder.endsWith("0.0") ? section.fullOrder.substring(0, section.fullOrder.length - 4) : section.fullOrder;

  const [imageOpen, setImageOpen] = useState(false);
  const [altImageOpen, setAltImageOpen] = useState(Object.fromEntries(Object.entries(section.images || []).map(([k, v]) => [k, false])));
  const [hover, setHover] = useState(false);
  const [sectionOpen, setSectionOpen] = useState(section.order === "" && section.group === "");
  const [showAnnotations, setShowAnnotations] = useState(hasImages && section.order === "" && section.group === "");

  const [edit, setEdit] = useState(false);
  const [editTitle, setEditTitle] = useState(section.title);
  const [editText, setEditText] = useState(section.rawText);
  const [editOpts, setEditOpts] = useState(section.opts||{});
  // eslint-disable-next-line  react-hooks/exhaustive-deps
  const breadcrumb = useMemo(() => makeBreadcrumbs(partialOrder, section.path||[], classes.breadcrumb), [partialOrder, section.path])
  const hasOpened = useRef(isSectionRoot);

  const annotated = section.fullOrder.endsWith("0.0") && section.images && Object.keys(section.images||[]).length > 0 && Object.keys(section.images)[0].endsWith("Labeled");
  const annotation = !shouldAnnotated ? null : <div className={classes.label}>{section.order}</div>;
  const locator = section.group === "" && section.order === "" ?  `LifeNaut Help: Section ${section.section}`
      : <>
        <div className={classes.order}>
          {partialOrder}
        </div>
        {breadcrumb}
      </>;
  const title = section.group !== "" || section.order !== "" ? section.title : `${section.title}`;

  useEffect(() => setEditTitle(section.title), [section.title])
  useEffect(() => setEditText(section.rawText), [section.rawText])
  useEffect(() => setEditOpts(section.opts), [section.opts])


  const location = useLocation();
  useEffect(() => {
    if(location.hash.startsWith(`#help_${partialOrder}`)){
      const isOpen = sectionOpen;
      if(hasChildren) {
        setSectionOpen(true);
      }
      if(location.hash === `#help_${section.fullOrder}`){
        setTimeout(() => {
          const el = document.getElementById(`help_${section.fullOrder}`);
          if(el) {
            el.scrollIntoView({behavior: 'smooth', block: 'start'});
          }
        }, isOpen || section.path.length <= 2 ? 200 : 400);
      }
    }
    // eslint-disable-next-line  react-hooks/exhaustive-deps
  }, [location.hash]);

  useEffect(() => {
    setShowAnnotations(hasImages && sectionOpen);
    if(!sectionOpen && hasOpened.current) {
      const sectionAnchor = document.getElementById(`help_${section.fullOrder}`);
      const sectionTop = sectionAnchor.parentElement?.parentElement?.offsetTop;
      const scrollTop = document.getElementById("helpDialog").scrollTop;
      if(scrollTop > sectionTop) {
        setTimeout(() => {
          if (sectionAnchor) {
            sectionAnchor.scrollIntoView();
          }
        }, 0);
      }
    }else if(sectionOpen){
      hasOpened.current = true;
    }
    // eslint-disable-next-line  react-hooks/exhaustive-deps
  }, [sectionOpen]);

  const renderTopInner = () =>
    <>
      <div className={classes.topText}>
        <div className={isSectionRoot ? classes.locatorRoot : classes.locator}>
          {locator}
        </div>
        <div className={classes.name}>
          {annotation}
          <div className={classes.title}>
            {title}
          </div>
        </div>
      </div>
      {!sectionOpen ?
          hasChildren ?
            <div className={classes.sectionButton}>
              <IconButton onClick={() => setSectionOpen(!sectionOpen)}>
                {sectionOpen ? <CloseArrow /> : <OpenArrow /> }
              </IconButton>
            </div>
            : null
        : !!section.opts?.noImage ? null :
          <div className={classes.thumbnail}>
            <img
              className={classes.thumbnailImage}
              src={`/v2/help_files/images/${section.fullOrder}.${section.name}.png`}
              alt={section.title}
            />
          </div>
      }
    </>;

  const renderTop = (style) =>
    style === "card" ?
    <Card
      className={`${classes.top} ${isSectionRoot ? classes.topRoot : classes.topSection}`}
      style={!isSectionRoot && hasChildren ? {cursor: "pointer"} : null }
      onClick={!isSectionRoot && hasChildren ? () => setSectionOpen(!sectionOpen) : null }
      raised={!isSectionRoot && hasChildren && hover}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {renderTopInner()}
    </Card>
    : <div className={`${classes.top} ${classes.topSingle}`}>
        {renderTopInner()}
      </div>;

  const stickyTitleSpace = renderTop(hasChildren || isSectionRoot ? "card" : "div");
  const imageSection = hasImages && showAnnotations ? Object.values(section.images)[0] : section;
  const toggleImage = !hasImages || !sectionOpen ? null : <div className={classes.annotateLink}>
    [ <Button className={classes.annotateLinkButton} variant="text" onClick={() => setShowAnnotations(!showAnnotations)}>{showAnnotations ? "Hide" : "Show"} Annotations</Button> ]
    </div>;

  const saveHelpEdit = () => {
    addHelpEdit(`${section.fullOrder}.${section.name}`, editTitle, editText, editOpts, () => setEdit(false));
  }

  return (
    <>
      <div className={`${classes.root} ${!!parentStickyTitle && currentSection === `#help_${section.fullOrder}` ? classes.selected : ""}`}>
        <div className={classes.anchorRoot}>
          <div id={`help_${section.fullOrder}`} className={classes.anchor}>
            {parentStickyTitle}
          </div>
        </div>
        <div className={isSectionRoot ? `${classes.sticky} ${classes.stickyRoot}` : sectionOpen ? classes.sticky : hasChildren ? classes.closed : classes.single} >
          {renderTop(hasChildren || isSectionRoot ? "card" : "div")}
        </div>
        <div className={classes.body}>
          <div className={`${classes.content} ${!!parentStickyTitle && currentSection === `#help_${section.fullOrder}` ? classes.selected : ""}`}>
            {!hasSections && !!section.opts?.noImage ? null :
              <div className={classes.imagesToc}>
                {!hasSections ? null :
                  <Slide in={sectionOpen} direction="right" timeout={100} mountOnEnter unmountOnExit>
                    <div className={classes.toc}>
                      <HelpSectionTOC section={section} onlyChildren={true} recursive={false} />
                    </div>
                  </Slide>
                }
                {!!section.opts?.noImage ? null :
                  <div className={classes.image}>
                    <img
                      className={imageOpen ? classes.mainImageLg : classes.mainImage}
                      src={`/v2/help_files/images/${imageSection.fullOrder}.${imageSection.name}.png`}
                      alt={imageSection.title}
                      onClick={() => setImageOpen(!imageOpen)}
                    />
                    {toggleImage}
                  </div>
                }
              </div>
            }
            {!section.text ? null :
              <div className={classes.text}>
                <ReactMarkdown components={{ a: LinkRenderer}}>
                  {section.text}
                </ReactMarkdown>
              </div>
            }
          </div>
          {!ENABLE_HELP_EDIT || !isAdmin ? null : <>
            <IconButton
              size={"small"}
              onClick={() => setEdit(!edit)}
            ><EditIcon size={"small"} /></IconButton>
            {!edit ? null :
              <div className={classes.edit}>
                <TextField
                  label={"Title"}
                  value={editTitle}
                  onChange={e => setEditTitle(e.target.value)}
                />
                <TextField
                  label={"Text"}
                  value={editText}
                  onChange={e => setEditText(e.target.value)}
                  multiline={true}
                  minRows={3}
                />
                <div className={classes.editActions}>
                  <Button
                    variant={"contained"}
                    color={"primary"}
                    onClick={saveHelpEdit}
                  >Save</Button>
                  <Button
                    variant={"contained"}
                    color={"primary"}
                    onClick={() => setEdit(false)}
                  >Cancel</Button>
                </div>
              </div>
            }
          </>}
          <Collapse in={sectionOpen} timeout={100}>
            {hasAltImages ?
              <div className={classes.altImages}>
                {Object.entries(section.images).slice(1).map(([k, v]) => {
                  return <img key={k} className={altImageOpen[k] ? classes.mainImageLg : classes.mainImage}
                              src={`/v2/help_files/images/${k}.png`}
                              alt={v.title}
                              onClick={() => setAltImageOpen({...altImageOpen, [k]:!altImageOpen[k]})}
                  />;
                })}
              </div>
              : null
            }
            {hasSections ?
              <div>
                {Object.entries(section.sections).map(([k, v]) => {
                  return <HelpSection
                    key={k}
                    sectionId={k}
                    section={v}
                    shouldAnnotated={annotated}
                    parentStickyTitle={stickyTitleSpace}
                    addHelpEdit={addHelpEdit}
                    currentSection={currentSection}
                    isAdmin={isAdmin}
                  />;
                })}
              </div>
              : null
            }
          </Collapse>
        </div>
      </div>
    </>
  );
}

export default HelpSection;
